import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {createSportsEvents} from './JSONLDSportsEvent';
import JsonLD from 'modules/Common/components/JsonLD';

export default class RaceJSONLD extends Component {
  static propTypes = {
    meeting: PropTypes.object,
    sport: PropTypes.string,
    type: PropTypes.string,
    raceId: PropTypes.number
  };

  render() {

    const {
        meeting: {

            meeting_summary: {
              course: {
                name: courseName = ''
              } = {}
            } = {},
            races : races = []
      } = {},
      sport,
      type: type = 'racecard',
      raceId: singleRaceId = ''

    } = this.props;

    const racesToShow = races.filter(({
       race_summary_reference: {
          id: raceId = ''
        } = {}
      } = {}
    ) => {

    return ((singleRaceId === raceId) || singleRaceId === '');
    });

    const sportsEvents = createSportsEvents(racesToShow, courseName, sport, type);

    return sport && <JsonLD data={sportsEvents}/>;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/RaceJSONLD.js